import { UuidHelper } from '@/utils/uuid.helper';
import { IIdentity } from '@/connectors/identity/identity.model';

export class LocalStorageHelper {
  static getClientId(): string {
    let industryPortalClientId = localStorage.getItem('IndustryPortalClientId');

    if (!industryPortalClientId) {
      industryPortalClientId = UuidHelper.generate();
      localStorage.setItem('IndustryPortalClientId', industryPortalClientId);
    }

    return industryPortalClientId;
  }

  static getIdentity() {
    const identityPayload = localStorage.getItem('identity');
    if (identityPayload) {
      return JSON.parse(identityPayload);
    }

    return null;
  }
}
